import React from 'react'
import { isEmpty, isNull, isUndefined } from 'lodash'
import DataTable, { TableActions } from '../../../DataTable'
import Loading from '../../../Loading'
import UbliqueColumn from '../Column'
import UbliqueRow from '../Row'
import cn from 'classnames'

import './index.scss'

const StripeTables = ({ tables, className }) => {
  const renderTable = ({ tableTitle, ...props }) => {
    if (isUndefined(props)) return <Loading />
    if (isNull(props)) return <div>No Data</div>
    return (
      <>
        {tableTitle && <h4 className='stripe-table-title'>{tableTitle}</h4>}
        <DataTable
          {...props}
          extraHeaderComponent={
            !isEmpty(props?.extraHeaderComponent) && (
              <TableActions {...props?.extraHeaderComponent} />
            )
          }
        />
      </>
    )
  }

  return (
    <UbliqueRow className={cn('ublique-row-tables', className)}>
      {tables.map(({ config, tableProps }, idx) => (
        <UbliqueColumn
          sm={config?.sm}
          md={config?.md}
          lg={config?.lg}
          key={`page-output-stripe-table-${idx}`}
        >
          {renderTable(tableProps)}
        </UbliqueColumn>
      ))}
    </UbliqueRow>
  )
}

export default StripeTables
